import React, { FunctionComponent, RefObject } from 'react';
import { DataCategory, DataValueCompanyPageEmployments } from "../../../types/companyDetail";

type Props = {
  companyId: number;
  recruitmentEmploymentIds: number[];
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageEmployments;
  employmentRef?: RefObject<HTMLElement>;
};

export const Presentation: FunctionComponent<Props> = ({
  companyId,
  recruitmentEmploymentIds,
  dataCategory,
  dataValue,
  employmentRef,
}) => {
  const items: Array<{ id: number; label: string; q: string }> = [
    { id: 1, label: '新卒', q: '新卒' },
    { id: 2, label: 'インターン', q: 'インターン' },
    { id: 3, label: 'アルバイト', q: 'アルバイト' },
    { id: 4, label: '転職・中途', q: '転職・中途' },
    { id: 5, label: '副業・業務委託', q: '副業・業務委託' },
    { id: 6, label: 'その他', q: 'その他' },
  ];

  const has = (n: number) => recruitmentEmploymentIds.includes(n);

  return (
    <section ref={employmentRef} className="company__page__recruitments maskno" id="employments">
      <div className="company__page__recruitments__header employments">
        <h2 className="company__page__recruitments__header--titleSub">雇用形態から求人を探す</h2>
      </div>
      <div className="company__page__recruitments__wrapper flex gtm-company_employment-view-count" data-event-name='company_employment on screen' data-category={dataCategory} data-value={dataValue}>
        {items.map(({ id, label, q }) => (
          <a
            key={id}
            href={`/companies/${companyId}/recruitments?employment_type=${encodeURIComponent(q)}`}
            className={`company__page__recruitments__wrapper--link ${!has(id) && 'disabled'}`}
            rel="nofollow"
            data-event="click"
            data-category={dataCategory}
            data-value={dataValue}
          >
            {label}
          </a>
        ))}
      </div>
    </section>
  );
};
